import React, {createContext} from "react";

export const LevelContext = createContext<LevelContextTypes>({} as LevelContextTypes)

type LevelContextTypes = {
    selectedItems: number[]
    setSelectedItems: React.Dispatch<React.SetStateAction<number[]>>
}